/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-ignore TS(6133): 'React' is declared but its value is never read.
import { useI18n } from "intl/useI18n";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { INCHES_PER_FOOT } from "./common/constants";
import { useDtfStore } from "./store";
import EnhancementTierLabel from "./common/EnhancementTierLabel.vue";
import { cn } from "tailwind-variants";
import "./ArtworkHistoryGridItem.scss";

function ArtworkHistoryGridItem({
  artwork,
  isSelected = false,
  isShownTier = false,
  isShownCheckbox = false,
  index,
  onSelectLibrary,
  onDownloadArtwork,
  ...restProps
}: any) {
  // @ts-ignore TS(6133): 't' is declared but its value is never read.
  const { t: _t } = useI18n();
  const store = useDtfStore();

  function printAsIs() {
    return artwork.useFootLength;
  }

  function date() {
    if (artwork.purchasedDate) return `Purchased on ${artwork.purchasedDate}`;
    return `Uploaded on ${artwork.uploadedOn}`;
  }

  function isStandardArtwork() {
    // @ts-ignore TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function sizeText({ metadata }: any) {
    const { widthInch, heightInch } = metadata;
    const height = printAsIs() ? (heightInch / INCHES_PER_FOOT).toFixed(0) : heightInch;
    const unit = printAsIs() ? "'" : '"';
    return `${widthInch}" x ${height}${unit}`;
  }

  // eslint-disable-next-line no-shadow
  function selectLibrary(artwork: any, index: any) {
    // eslint-disable-line no-shadow
    if (isShownCheckbox) onSelectLibrary(artwork, index);
  }

  return (
    <div {...restProps} className={cn("artwork-history-grid-item scope-864ba11a")}>
      <div
        className={cn(
          "artwork-history-grid-item__artwork-image-container scope-864ba11a",
          isShownCheckbox && "artwork-history-grid-item__artwork-image-container--clickable"
        )}
        onClick={() => {
          selectLibrary(artwork, index);
        }}
        data-testid="artwork-history-grid-item-artwork-image-container"
      >
        <img
          className={cn("artwork-history-grid-item__artwork-image scope-864ba11a")}
          src={artwork.previewUrl}
          alt={`Artwork - ${artwork.name}`}
        />
        {isShownTier && artwork.enhancementTier ? (
          <EnhancementTierLabel
            className={cn("artwork-history-grid-item__enhancement-tier scope-864ba11a")}
            tier={artwork.enhancementTier}
            data-testid="artwork-history-grid-item-enhancement-tier"
          />
        ) : null}
      </div>
      <button
        className={cn("artwork-history-grid-item__download scope-864ba11a")}
        type="button"
        onClick={() => {
          onDownloadArtwork(artwork.downloadUrl, artwork.name);
        }}
        data-testid="artwork-history-grid-item-download"
      >
        <UseSvg
          className={cn("artwork-history-grid-item__download-icon scope-864ba11a")}
          icon="download-line"
          data-testid="artwork-history-grid-item-download-icon"
        />
      </button>
      {isShownCheckbox ? (
        <button
          className={cn(
            "artwork-history-grid-item__checkbox scope-864ba11a",
            isSelected && "artwork-history-grid-item__checkbox--selected",
            isStandardArtwork() && "artwork-history-grid-item__checkbox--standard-artwork"
          )}
          type="button"
          onClick={() => {
            selectLibrary(artwork, index);
          }}
          data-testid="artwork-history-grid-item-checkbox"
        >
          <UseSvg
            className={cn("artwork-history-grid-item__checkbox-icon scope-864ba11a")}
            icon="check"
            data-testid="artwork-history-grid-item-checkbox-icon"
          />
        </button>
      ) : null}
      <div
        className={cn("artwork-history-grid-item__info-name scope-864ba11a")}
        title={artwork.name}
      >
        {artwork.name}
      </div>
      <div className={cn("artwork-history-grid-item__info-text scope-864ba11a")}>
        {" "}
        Size: {sizeText(artwork)}
      </div>
      <div
        className={cn(
          "artwork-history-grid-item__info-text artwork-history-grid-item__info-text-date scope-864ba11a"
        )}
      >
        {date()}
      </div>
    </div>
  );
}

export default ArtworkHistoryGridItem;
